module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "chatBotAvatarGala.36771cea.png";